module.exports = __webpack_public_path__ + "b5272633d67c139c7fdfbda50e0b8a73.svg";